import { computed, ref } from 'vue';

import expirableLocalStorage from '@/utils/runtime/expirableLocalStorage.js';

const storeHashmap = ref<Record<string, { value: any; expired: number }>>({});

export const useExpirableLocalStorage = <T>(
  key: string,
  defaultValue: T,
  defaultExpired: number,
) => {
  const storeValue = computed(() => storeHashmap.value[key]?.value);

  const setValue = (value: T, newExpired?: number) => {
    expirableLocalStorage.set(key, value, newExpired);
    const result = expirableLocalStorage.get(key);
    if (result) { storeHashmap.value[key] = result; }
  };

  const init = () => {
    if (Object.hasOwn(storeHashmap.value, key)) { return; }

    const storageData = expirableLocalStorage.get(key);

    if (storageData?.value === null) {
      setValue(defaultValue, defaultExpired);
    } else if (storageData) {
      storeHashmap.value[key] = storageData;
    }
  };

  init();

  return {
    value: storeValue,
    setValue,
  };
};
